import React from 'react';
import PropTypes from 'prop-types';
import MaterialTable from 'material-table';
import Skeleton from '@material-ui/lab/Skeleton';

const SkeletonGrid = ({ title }) => (
  <MaterialTable
    title={title}
    columns={[{
      Field: "_", render: rowData => (
        <Skeleton />
      )
    }]}
    data={[{ "_": "" }, { "_": "" }, { "_": "" }, { "_": "" }, { "_": "" }, { "_": "" }]}
  />
)

SkeletonGrid.propTypes = {
  title: PropTypes.string
}

SkeletonGrid.defaultProps = {
  title: ""
}

export default SkeletonGrid;